module.exports = __webpack_public_path__ + "./docs/img/icon-copy-text.2fac4bb3f93eaa8d62dd758c3eaf9940.svg";